import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'

class ReportsBi extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('enrollments/net', this.props.activeCenter)
    } else {
      this.props.getNetExcel()
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { width, data } = this.state
    return (
    //   <ReportTemplate
    //     title="Altas y Bajas"
    //     date={data[0] &&
    //       { initial: data[0].day, end: data[data.length - 1].day }}
    //     onClick={this.download}
    //     loading={!(data[0] !== undefined)}
    //   >
    //     {data[0] !== undefined &&
    //       <BarChart
    //         width={width < 763 ? 400 : 648}
    //         height={width < 763 ? 300 : 400}
    //         data={data}
    //         margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
    //       >
    //         <CartesianGrid vertical={false} />
    //         <XAxis dataKey="hour" />
    //         <YAxis />
    //         <Tooltip />
    //         <Legend content={<CustomizedLegend />} />
    //         <Bar dataKey="Altas" stackId="a" fill="#bb4ab7" />
    //         <Bar dataKey="Bajas" stackId="a" fill="#2A517F" />
    //       </BarChart>
    //     }
    //   </ReportTemplate>
    <div>
        <iframe 
            width={window.innerWidth} 
            height={window.innerHeight - 93}
            src="https://app.powerbi.com/view?r=eyJrIjoiNDIzNzMyYjAtMGMzMS00YzM0LTlkNjAtNDcwNTJjYzMyNTI2IiwidCI6IjY4YjU2MmQyLTllN2YtNDdhMy1iZTEzLWVkZGJjNGYyNzAzMyIsImMiOjR9" 
            frameBorder="0" 
            allowFullScreen="true"
        />
    </div>
    )
  }
}


const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportsBi))



// WEBPACK FOOTER //
// ./src/Containers/Reports/ReportsBi.jsx